import styled from "styled-components";

export const SectionShellContainer = styled.div`
  position: fixed;
  top: 48px;
  z-index: 50;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #fff;
  width: ${(p) => (p.$containerWidth != null ? `${p.$containerWidth}px` : 'calc(100% - 60px)')};
  left: ${(p) => (p.$containerLeft != null ? `${p.$containerLeft}px` : 'auto')};

  transform: translateY(${(p) => (p.$show ? "0" : "-100%")});
  opacity: ${(p) => (p.$show ? 1 : 0)};
  transition: transform 160ms ease-in-out, opacity 160ms ease-in-out;
  will-change: transform, opacity;
`;
